import React, { Fragment } from 'react';
import { Card, Row, Col, Button } from 'antd';
import { connect } from 'dva';
import { routerRedux } from 'dva/router';
import styles from './Card.less';
import EditBankCardModal from '../Modal/EditBankCard.js';

@connect(({ merchantBusinessMy, loading }) => ({
  loading: loading.effects['merchantBusinessMy/fetchCardInfo'],
  cardInfo: merchantBusinessMy.cardInfo,
}))
export default class CardInfoCard extends React.Component {
  constructor(props) {
    super(props);

    this.renderBankCard = this.renderBankCard.bind(this);
    this.handelAddbankCard = this.handelAddbankCard.bind(this);
    this.handleShowEditBankCardModal = this.handleShowEditBankCardModal.bind(this);
    this.handleRefreshCardInfo = this.handleRefreshCardInfo.bind(this);
  }

  // componentDidMount() {
  //   this.props.dispatch({ type: 'merchantBusinessMy/fetchCardInfo' });
  // }

  handelAddbankCard() {
    this.props.dispatch(routerRedux.push('/merchant/business/my/add-bank-card'));
  }

  handleShowEditBankCardModal() {
    this.props.dispatch({
      type: 'merchantBusinessMy/toggleModalVisibility',
      modal: { showEditBankCard: true },
    });
  }

  handleRefreshCardInfo() {
    this.props.dispatch({ type: 'merchantBusinessMy/fetchCardInfo' });
  }

  renderBankCard() {
    const { status, bankNo } = this.props.cardInfo;

    if (status !== 2) {
      return (
        <Button ghost type="primary" icon="plus" onClick={this.handelAddbankCard}>
          绑定银行卡
        </Button>
      );
    }

    return (
      <div className="bank-card-content">
        {bankNo}
        <Button ghost type="primary" onClick={this.handleShowEditBankCardModal}>
          更换银行卡
        </Button>
      </div>
    );
  }

  render() {
    const { labelLayout, contentLayout, cardInfo, loading } = this.props;

    return (
      <Fragment>
        <Card title="个人资料" loading={loading} className={styles.root} bordered={false}>
          <Row>
            <Col {...labelLayout}>开户名称：</Col>
            <Col {...contentLayout}>{cardInfo.name}</Col>
          </Row>

          <Row>
            <Col {...labelLayout}>身份证号：</Col>
            <Col {...contentLayout}>{cardInfo.idNo}</Col>
          </Row>

          <Row>
            <Col {...labelLayout}>绑定手机号：</Col>
            <Col {...contentLayout}>{cardInfo.mobile}</Col>
          </Row>

          <Row>
            <Col {...labelLayout} className="bank-card-label">
              银行卡号：
            </Col>
            <Col {...contentLayout}>{this.renderBankCard()}</Col>
          </Row>
        </Card>
        <EditBankCardModal saveSuccessCallback={this.handleRefreshCardInfo} />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Merchant/Business/My/Card/CardInfo.js